/** Maps a sync status to a semantic intent for badge colouring. */
export var SYNC_STATUS_INTENT = {
  queued: "base",
  in_progress: "attention",
  sent: "base",
  consumed: "brand",
  delivered: "success",
  failed: "urgent"
};

/** Human-readable label for each sync status. */
export var SYNC_STATUS_LABEL = {
  queued: "Queued",
  in_progress: "In progress",
  sent: "Sent",
  consumed: "Awaiting confirmation",
  delivered: "Confirmed",
  failed: "Failed"
};

/** Ordered lifecycle stages for a successful submission. */
export var SYNC_LIFECYCLE_COMPLETE = ["Queued", "In progress", "Sent", "Awaiting confirmation", "Confirmed"];

/** Lifecycle stages shown when a submission fails. */
export var SYNC_LIFECYCLE_FAILED = ["Queued", "In progress", "Failed"];

/** Index of each status within {@link SYNC_LIFECYCLE_COMPLETE}. */
export var SYNC_STATUS_INDEX = {
  queued: 0,
  in_progress: 1,
  sent: 2,
  consumed: 3,
  delivered: 4
};

/** Column headers for the sync submissions table. */
export var SYNC_TABLE_HEADERS = [{
  key: "submitted",
  labelKey: "submitted",
  fallback: "Submitted"
}, {
  key: "submitted_by",
  labelKey: "submitted_by",
  fallback: "Submitted by"
}, {
  key: "action",
  labelKey: "action",
  fallback: "Action"
}, {
  key: "target",
  labelKey: "target_encounter",
  fallback: "Target encounter"
}, {
  key: "lifecycle",
  labelKey: "lifecycle",
  fallback: "Lifecycle"
}, {
  key: "status",
  labelKey: "status",
  fallback: "Status"
}];